<script>
    export default {
        computed: {
            errorMessage() {
                return this.$store.state.errorMessage;
            },
        },
    };
</script>

<template>
    <div v-if="errorMessage" class="error-notification">
        {{ errorMessage }}
    </div>
</template>
  
<style scoped>
    /* .error-notification {
        position: fixed;
        top: 10px;
        right: 10px;
        background-color: red;
        color: white;
        padding: 10px;
        border-radius: 5px;
    } */

    .error-notification {
        position: fixed;
        top: 10%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: red;
        color: white;
        padding: 10px;
        border-radius: 5px;
    }
</style>